export class ConsumersRegModel {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    password: string;
    registrationCode: string;

    // AC-4441 - five emergency-contact slots, the first two required. Property names
    // match the API's RegistrationModel exactly: slot 1 carries no numeric suffix.
    // Without these a consumer signs up with nobody for domiiRescue to alert.
    emergencyContactName: string;
    emergencyContactNumber: string;
    emergencyContactName2: string;
    emergencyContactNumber2: string;
    emergencyContactName3: string;
    emergencyContactNumber3: string;
    emergencyContactName4: string;
    emergencyContactNumber4: string;
    emergencyContactName5: string;
    emergencyContactNumber5: string;
}
